import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { categories, navButtons } from "@/mocks/siteData";

export default function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-white border-b border-background-200/70 shadow-sm"
          : "bg-white border-b border-background-200/40"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span className="text-lg md:text-xl font-heading font-bold text-foreground-950 tracking-tight whitespace-nowrap">
              AcBuySpreadsheet
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-4">
            <Link
              to="/"
              className="px-3 py-2 text-sm font-medium text-foreground-800 hover:text-foreground-950 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Home
            </Link>

            <div className="relative">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                onMouseEnter={() => setIsDropdownOpen(true)}
                onMouseLeave={() => setIsDropdownOpen(false)}
                className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-foreground-800 hover:text-foreground-950 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>Categories</span>
                <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${isDropdownOpen ? "rotate-180" : ""}`}></i>
              </button>

              {isDropdownOpen && (
                <div
                  className="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl border border-background-200/70 overflow-hidden shadow-lg"
                  onMouseEnter={() => setIsDropdownOpen(true)}
                  onMouseLeave={() => setIsDropdownOpen(false)}
                >
                  <div className="max-h-80 overflow-y-auto py-2">
                    {categories.map((cat) => (
                      <a
                        key={cat.id}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors whitespace-nowrap"
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-accent-500 flex-shrink-0"></span>
                        {cat.name}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/article/acbuy-sneaker-spreadsheet-2026"
              className="px-3 py-2 text-sm font-medium text-foreground-800 hover:text-foreground-950 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Shopping Guide
            </Link>

            {navButtons.map((btn) => (
              <a
                key={btn.label}
                href={btn.url}
                target="_blank"
                rel="noopener nofollow"
                className="px-5 py-2.5 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                {btn.label}
              </a>
            ))}
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden flex items-center justify-center w-10 h-10 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className={`text-xl text-foreground-800 ${isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden border-t border-background-200/70 bg-white max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="flex items-center gap-3 px-3 py-3 text-sm font-semibold text-foreground-900 hover:bg-background-100 rounded-lg transition-colors"
            >
              <i className="ri-home-4-line text-lg text-accent-500"></i>
              Home
            </Link>

            <Link
              to="/article/acbuy-sneaker-spreadsheet-2026"
              onClick={() => setIsMobileMenuOpen(false)}
              className="flex items-center gap-3 px-3 py-3 text-sm font-semibold text-foreground-900 hover:bg-background-100 rounded-lg transition-colors"
            >
              <i className="ri-book-open-line text-lg text-accent-500"></i>
              Shopping Guide
            </Link>

            <hr className="my-2 border-background-200" />
            <p className="text-xs font-semibold text-foreground-400 uppercase tracking-wider px-2 py-1">
              Categories
            </p>
            <div className="grid grid-cols-1 gap-0.5">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 rounded-lg transition-colors"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-accent-500 flex-shrink-0"></span>
                  {cat.name}
                </a>
              ))}
            </div>
            <div className="pt-3 space-y-2">
              {navButtons.map((btn) => (
                <a
                  key={btn.label}
                  href={btn.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block w-full text-center px-5 py-3 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap"
                >
                  {btn.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}